export default "__VITE_ASSET__k1xtThhi__"